import { formatNullableDateToLocal } from "@utils/dateUtils";

/**
 * The case summary's sub-title line, per the brand guidelines:
 * subject · matter type · date · recipient, e.g.
 *   "Jane Citizen · Workers Compensation · Assessment 29-06-2026 · Dr Sam Lee"
 *
 * The matter type is the case's free-text `case_type` (the scheme name experts
 * see as "Case Type"). Missing values drop their segment; returns an empty
 * string when there's nothing to show.
 */
export const buildSummarySubtitle = ({
  examineeName,
  caseType,
  appointmentDate,
  doctorName,
}: {
  examineeName?: string | null;
  caseType?: string | null;
  appointmentDate?: string | null;
  doctorName?: string | null;
}): string => {
  const assessmentDate = formatNullableDateToLocal(appointmentDate, undefined, "");

  return [
    examineeName?.trim(),
    caseType?.trim(),
    assessmentDate && `Assessment ${assessmentDate}`,
    doctorName?.trim(),
  ]
    .filter(Boolean)
    .join(" · ");
};
